export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5138.634f8af5.jpg";